<div class="row align-items-center p-1 d-lg-none">
  <div class="col">
    <button class="btn btn-sm btn-outline-dark  " (click)="toggleSidebar()">
      <i class="bi bi-list fs-3"></i>
    </button>
  </div>

  <a routerLink="/" class="col d-block">
    <img src="assets/img/SellUp-Logo-Black.png" class="image-fluid" alt="R2Wear" width="120" />
  </a>
</div>

<a routerLink="/" class="col d-none p-4  d-lg-block">
  <img src="assets/img/SellUp-Logo-Black.png" class="image-fluid" alt="R2Wear" width="120" />
</a>



<nav class="bg-white h-100"
  [ngClass]="{'d-none d-lg-block': !isSidebarOpen, 'd-block z-3 position-fixed top-0 start-0 w-100 h-100 ': isSidebarOpen }">
  <div class="row align-items-center d-lg-none p-1">
    <div class="col">
      <button class="btn btn-sm btn-outline-dark " (click)="toggleSidebar()">
        <i class="bi bi-x fs-3"></i>
      </button>
    </div>


    <a routerLink="/" class="col d-block">
      <img src="assets/img/SellUp-Logo-Black.png" class="image-fluid" alt="R2Wear" width="120" />
    </a>
  </div>
  <!-- NAVBAR RETAILER -->
  <div class="list-group list-group-flush" [hidden]="!(roleUserLogged == 'RETAILER')">
    <a routerLink="/" class="list-group-item list-group-item-action px-4 py-3" aria-current="true"
      [ngClass]="{'active': location.path() == '/dashboard'}">
      <i class="bi bi-house me-1"></i>
      {{ "MENU.DASHBOARD" | translate }}
    </a>

    <button class="list-group-item list-group-item-action px-4 py-3 d-flex" (click)="prodottiShow = !prodottiShow">
      <i class="bi bi-shop-window me-2"></i>
      {{ "MENU.PRODOTTI" | translate }}
      <i class="bi bi-chevron-down ms-auto" [hidden]="!prodottiShow"></i>
      <i class="bi bi-chevron-up ms-auto" [hidden]="prodottiShow"></i>
    </button>

    <li class="list-group-item list-group list-group-flush" [hidden]="!prodottiShow">
      <a class="list-group-item list-group-item-action px-2 py-2 " routerLink="/warehouse" routerLinkActive="active">
        {{ "MENU.MAGAZZINO" | translate }}
      </a>
      <a class="list-group-item list-group-item-action px-2 py-2 " routerLink="/movimenti" routerLinkActive="active">
        {{ "MENU.MOVIMENTI" | translate }}
      </a>
    </li>

    <a routerLink="/brands" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-shop me-1"></i>
      {{ "MENU.BRANDS" | translate }}
    </a>

    <a routerLink="/marketplace" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-shop-window me-1"></i>
      {{ "MENU.MARKETPLACE" | translate }}
    </a>

    <a routerLink="/orders" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-download me-1"></i>
      {{ "MENU.ORDERS" | translate }}
    </a>

    <a routerLink="/profile" routerLinkActive="active" class="list-group-item list-group-item-action px-4 py-3 "
      aria-current="true">
      <i class="bi bi-gear me-1"></i>
      {{ "MENU.SETTINGS" | translate }}
    </a>
  </div>

  <!-- NAVBAR BRAND  -->

  <div class="list-group list-group-flush" [hidden]="!(roleUserLogged == 'BRAND')">
    <a routerLink="/dashboard" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-house me-1"></i>
      {{ "MENU.DASHBOARD" | translate }}
    </a>

    <li class="list-group-item list-group-item-action px-4 p-3" aria-current="true">
      <div class="py-2">
        <i class="bi bi-archive me-1"></i>
        {{ "MENU.PRODUCTS" | translate }}
      </div>
      <ul class="list-group list-group-flush mt-2">
        <a class="list-group-item list-group-item-action ps-4 py-2" routerLink="/warehouse" routerLinkActive="active">
          {{ "MENU.MAGAZZINO" | translate }}
        </a>
        <a class="list-group-item list-group-item-action ps-4 py-2" routerLink="/movimenti-magazzino"
          routerLinkActive="active">
          {{ "MENU.MOVIMENTI_MAGAZZINO" | translate }}
        </a>
        <a routerLink="/products/detail/-1" class="list-group-item list-group-item-action ps-4 py-2"
          routerLinkActive="active">
          {{ "MENU.NEW_PRODUCT" | translate }}
        </a>
      </ul>
    </li>

    <a routerLink="/retailers-list" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-shop-window me-1"></i>
      {{ "MENU.RETAILERS" | translate }}
    </a>

    <a routerLink="/orders" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-download me-1"></i>
      {{ "MENU.ORDERS" | translate }}
    </a>

    <a routerLink="/preordini" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-wallet2 me-1"></i>
      {{ "MENU.PREORDINI" | translate }}
    </a>

    <a routerLink="/campionari" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-file-earmark-text me-1"></i>
      {{ "MENU.CAMPIONARI" | translate }}
    </a>

    <a routerLink="/clienti" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-people me-1"></i>
      {{ "MENU.CLIENTS" | translate }}
    </a>

    <a routerLink="/listini" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-collection me-1"></i>
      {{ "MENU.LISTINI" | translate }}
    </a>

    <a routerLink="/agenti" class="list-group-item list-group-item-action px-4 py-3 " aria-current="true"
      routerLinkActive="active">
      <i class="bi bi-people me-1"></i>
      {{ "MENU.AGENTS" | translate }}
    </a>


    <li class="list-group-item list-group-item-action px-4 p-3" aria-current="true">
      <div class="py-2">
        <i class="bi bi-archive me-1"></i>
        {{ "MENU.UTILITIES" | translate }}
      </div>
      <ul class="list-group list-group-flush mt-2">
        <a class="list-group-item list-group-item-action ps-4 py-2" routerLink="/collections" routerLinkActive="active">
          {{ "MENU.COLLECTIONS" | translate }}
        </a>
        <a class="list-group-item list-group-item-action ps-4 py-2" routerLink="/colors" routerLinkActive="active">
          {{ "MENU.COLORS" | translate }}
        </a>
        <a class="list-group-item list-group-item-action ps-4 py-2" routerLink="/fabrics" routerLinkActive="active">
          {{ "MENU.FABRICS" | translate }}
        </a>

      </ul>
    </li>



    <a routerLink="/profile" routerLinkActive="active" class="list-group-item list-group-item-action px-4 py-3 "
      aria-current="true">
      <i class="bi bi-gear me-1"></i>
      {{ "MENU.SETTINGS" | translate }}
    </a>
  </div>




  <!-- SUPER ADMIN -->
  <ul class="navbar-nav" [hidden]="!(roleUserLogged == 'admin')">
    <li id="sidebar-dashboard" class="nav-item">
      <a class="nav-link " routerLink="/">
        <i class="fa-regular fa-house me-1"></i>
        <span class="nav-link-text">
          {{ "MENU.DASHBOARD" | translate }}
        </span>
      </a>
    </li>
    <li id="sidebar-importer" class="nav-item">
      <a class="nav-link " routerLink="/import-superadmin">
        <i class="fas fa-upload me-1"></i>
        <span class="nav-link-text">
          {{ "MENU.IMPORT" | translate }}
        </span>
      </a>
    </li>
  </ul>
</nav>
